import React, { useState } from 'react';
import { auth } from "../../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import BeatLoader from "react-spinners/BeatLoader";
import Request from "./Request.jsx";
import UploadPost from './UploadPost';
import AdminPost from './AdminPost';
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";

const AdminPage = () => {

    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isSignedIn, setIsSignedIn] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault()
        setErrors(errors.splice(0, errors.length));
        setLoading(true);
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setIsSignedIn(true);
                console.log("Signed In");
                setLoading(false);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setErrors([...errors, errorCode + ' : ' + errorMessage]);
                setIsSignedIn(false);
                setLoading(false);
            });
        
        setPassword('');
        setEmail('');
    }
    if (isLoading) {
        return (
            <div className="container  text-center" style={{ marginTop: '10rem', marginBottom: '10rem' }}>
                <BeatLoader />
            </div>
        );
    }
    if (isSignedIn) {
        return (
            <Container fluid id="admin" style={{ marginTop: '124px' }}>
                <Row>
                    <Col md={6} sm={12} >
                        <UploadPost />
                    </Col>
                    <Col md={6} sm={12} >
                        <Request />
                    </Col>
                </Row>
                <AdminPost />
            </Container>
        );
    }
    return (
        <Container
            fluid
            className="d-flex justify-content-center align-items-center"
            id="admin"
            style={{ minHeight: '90vh' }}
        >
            <div style={{ width: '80%', maxWidth: '500px' }}> {/* Restrict the form width to 50% of the screen */}
                <div style={{ color: 'red', marginBottom: '15px' }}>
                    {errors.map((message, index) => (
                        <div key={index}>
                            <span>{message}</span> <br />
                        </div>
                    ))}
                </div>

                <div className="mb-3 text-center">
                    <h3>LOGIN</h3>
                </div>

                <div className="mb-3">
                    <input
                        style={{ padding: '8px', width: '60%' }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        name="email"
                        type="text"
                        id="email"
                        placeholder="Email"
                    />
                </div>

                <div className="mb-3">
                    <input
                        style={{ padding: '8px', width: '60%' }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        name="password"
                        type="password"
                        id="password"
                        placeholder="Password"
                    />
                </div>

                <div className="d-flex justify-content-center">
                    <Button
                        variant="primary"
                        id="submit"
                        onClick={(e) => onSubmit(e)}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </Container>

       
    )
};

export default AdminPage